module.exports = __webpack_public_path__ + "img/social-media-marketing-landing.512294df.jpg";